import { Point } from '../../type/common.interface';

export function generateBounds(transformedBoundsPoints: Point[]) {
    const bounds = {
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity,
        width: 0,
        height: 0,
        offset: { x: 0, y: 0 },
    };

    transformedBoundsPoints.forEach((point) => {
        bounds.minX = Math.min(bounds.minX, point.x);
        bounds.minY = Math.min(bounds.minY, point.y);
        bounds.maxX = Math.max(bounds.maxX, point.x);
        bounds.maxY = Math.max(bounds.maxY, point.y);
    });

    bounds.width = bounds.maxX - bounds.minX;
    bounds.height = bounds.maxY - bounds.minY;
    bounds.offset.x = bounds.minX;
    bounds.offset.y = bounds.minY;

    return bounds;
}
